
const texts = {
    estadoDoc: 'Estado del documento:',
    publicadoPor: 'Publicado por:',
    estadoFirma: {
        cerrado:'Firma finalizada:',
        vencido:'Documento vencido:',
        rechazado:'Documento rechazado:',
        venceEl: 'Vence el:',
    },
    detallesDoc: 'Detalles del Documento',
    cargandoDoc: 'Cargando documento...',
    errorMessages: {
      rechazo:'EF003: No se pudo completar la acción. Probá de nuevo en unos minutos. Si sigue el problema, escribí a soporte.',
      networkError: 'EF001: Hubo un error de conexión con el servidor. Probá otra vez en unos minutos.',
      invalidNavigation: 'EF004: La dirección web (URL) no es válida.',
      cargarPDF: 'EF006 : No se pudo procesar el documento PDF. Probá nuevamente en unos minutos. Si el problema continúa, contactá a soporte.',
      documentoNoDisponible: 'EF006: No pudimos abrir el documento porque el servicio no devolvió el archivo PDF. Probá nuevamente en unos minutos. Si el problema continúa, contactá a soporte.',
      errorPeticion: 'EF005 : El servidor no responde a su solicitud. Intente nuevamente en unos minutos. Si el problema persiste contacte a soporte.',
      mensajeColor: 'EF007 : No se pudo comprobar si el documento está próximo a vencer.',
      formatFecha: 'EF008 : Hubo un error en el formato de la fecha.',
      enTransaccion: 'EF0035 : Otro usuario está usando este documento en este momento. Probá de nuevo en unos minutos. Si el problema continúa, contactá a soporte.',
      peticionTardo:'EF002: El servidor no respondió. Probá de nuevo en unos minutos. Si el problema sigue, escribí a soporte.',
    },
    getMessageAndColor:{
        pocosDias:'Atención: quedan pocos días para firmar',
        urgente:'Urgente: el documento está próximo a vencer',
    },
    buttons: {
      masDetalles: 'Más Detalles',
    },
  };

  export default texts;
